import { AuthContext } from 'contexts';
import { useLocalStorage } from 'react-use';
import { revokeToken, tokenIntrospection } from '../api/auth';

const AuthProvider = ({ children }) => {
  const [realAccessToken, setAccessToken] = useLocalStorage('accessToken', '', {
    raw: true,
  });
  const [refreshToken, setRefreshToken] = useLocalStorage('refreshToken', '', {
    raw: true,
  });
  const [impersonationToken, setImpersonationToken] = useLocalStorage(
    'impersonationToken',
    '',
    {
      raw: true,
    },
  );

  const handleUpdate = ({ accessToken, refreshToken }) => {
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
  };

  const handleReset = async () => {
    if (!!impersonationToken) await revokeToken(true);
    await revokeToken();
    setAccessToken('');
    setRefreshToken('');
    setImpersonationToken('');
    window.location.reload();
  };

  const stopImpersonating = async () => {
    if (
      localStorage.getItem('accessToken') ===
      localStorage.getItem('impersonationToken')
    ) {
      handleReset();
    } else {
      revokeToken(true)
        .then()
        .catch((error) => {
          console.error(
            `An error occurred while revoking the token: ${error.message}`,
          );
        })
        .finally(() => {
          setImpersonationToken('');
          window.location.href = '/';
        });
    }
  };

  const handleTokenIntrospection = async () => await tokenIntrospection();

  return (
    <AuthContext.Provider
      value={{
        accessToken:
          impersonationToken?.length > 0 ? impersonationToken : realAccessToken,
        refreshToken,
        logout: handleReset,
        onUpdate: handleUpdate,
        impersonating: !!impersonationToken,
        stopImpersonating: stopImpersonating,
        setImpersonationToken,
        isActiveToken: handleTokenIntrospection,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
